import { TableCell, TableHead, TableRow, TableSortLabel } from "@mui/material";
import { visuallyHidden } from "@mui/utils";

export default function ProductListHead({ headLabel, order, orderBy, onRequestSort }) {
  const createSortHandler = (property) => () => onRequestSort(property);

  return (
    <TableHead sx={{ backgroundColor: "grey.200" }}>
      <TableRow>
        {headLabel.map((headCell) => {
          const sortable = ['auto_suggestion_id', 'price'].includes(headCell.id);
          return (
            <TableCell
              key={headCell.id}
              align="center"
              sx={{
                textTransform: "uppercase",
                fontWeight: "bold",
                fontSize: "14px",
                width: headCell.id === "title" ? "20%" : "auto",
                padding: "16px 16px",
                cursor: sortable ? 'pointer' : 'default',
              }}
              sortDirection={orderBy === headCell.id ? order : false}
            >
              {sortable ? (
                <TableSortLabel
                  active={orderBy === headCell.id}
                  direction={orderBy === headCell.id ? order : 'asc'}
                  onClick={createSortHandler(headCell.id)}
                >
                  {headCell.label}
                  {orderBy === headCell.id ? (
                    <span style={visuallyHidden}>
                      {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                    </span>
                  ) : null}
                </TableSortLabel>
              ) : (
                headCell.label
              )}
            </TableCell>
          );
        })}
      </TableRow>
    </TableHead>
  );
}
